<template>
  <div
    class="theme-toggle"
    :title="theme === 'dark' ? '切换到白天模式' : '切换到夜间模式'"
    @click="toggle"
  >
    <i :class="theme === 'dark' ? 'el-icon-moon' : 'el-icon-sunny'"></i>
  </div>
</template>

<script>
import { getTheme, toggleTheme } from "@/utils/theme";
export default {
  name: "ThemeToggle",
  data() {
    return { theme: getTheme() };
  },
  methods: {
    toggle() {
      this.theme = toggleTheme();
    },
  },
};
</script>

<style scoped>
.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  cursor: pointer;
  color: var(--header-text, #cfe0f5);
  transition: background 0.2s ease, color 0.2s ease;
}
.theme-toggle:hover {
  background: rgba(56, 182, 255, 0.15);
  color: var(--accent, #38b6ff);
}
.theme-toggle i {
  font-size: 20px;
}
</style>
